export default function EnvelopeSheet({
  product,
  onSelect,
  onClose,
  enviando,
  cargandoProductos,
}) {
  return (
    <div
      className={`pos-envelope-sheet ${product ? "is-open" : ""}`}
      role="dialog"
      aria-modal="true"
      aria-labelledby="pos-envelope-sheet-title"
    >
      <div
        className="pos-envelope-sheet__backdrop"
        onClick={onClose}
        aria-hidden="true"
      />
      <div className="pos-envelope-sheet__panel">
        <div className="pos-envelope-sheet__handle" aria-hidden="true" />
        <div className="pos-envelope-sheet__head">
          <h3 id="pos-envelope-sheet-title" className="pos-envelope-sheet__title">
            {product ? product.nombre : ""}
          </h3>
          <p className="pos-envelope-sheet__subtitle">Elegir envoltura</p>
          <button
            type="button"
            className="pos-envelope-sheet__close"
            onClick={onClose}
            aria-label="Cerrar"
          >
            ×
          </button>
        </div>
        <div className="pos-envelope-sheet__body">
          {product &&
            (Array.isArray(product.envolturas) ? product.envolturas : []).map((ev) => (
              <button
                key={ev}
                type="button"
                className="btn full pos-envelope-sheet__option"
                onClick={() => {
                  onSelect(product, ev);
                  onClose();
                }}
                disabled={enviando || cargandoProductos}
              >
                {ev}
              </button>
            ))}
        </div>
        <div className="pos-envelope-sheet__footer">
          <button type="button" className="btn btn-light full" onClick={onClose}>
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}
